<template>
	<div ref="wrapper" class="select-box rounded-md text-xs">

		<div class="selected-currency flex items-center text-xs" :class="{ 'text-uppercase': true, 'rounded-md': true }"
			@click="toggleOption()">

			<div class="mr-4">
				{{ currencyName }}
			</div>

			<div class="app-select-arrow" :class="{ open: isOpen }">
				<IconArrow :color_prop="colorTheme" />
			</div>
		</div>

		<div v-if="isOpen" class="app-select-dropdown">
			<div class="form-group mb-3">
				<label for="selectCurrency" class="text-white font-weight-bold mb-2">Currency</label>
				<select id="selectCurrency" class="c-custom-select rounded" v-model="currency">
					<option value="usd">USD</option>
					<option value="idr">IDR</option>
				</select>
			</div>

			<table class="table mb-0">
				<thead>
					<tr>
						<th class="text-center" scope="col">Currency</th>
						<th class="text-center" scope="col">Buy</th>
						<th class="text-center" scope="col">Sell</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="text-center">USD</td>
						<td class="text-right">{{ this.$store.getters.getStreamingRate.streamBuy }}</td>
						<td class="text-right">{{ this.$store.getters.getStreamingRate.streamSell }}</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
import IconArrow from './icons/IconArrow.vue'

export default {
	name: 'ChangeCurrency',

	components: {
		IconArrow,
	},

	data() {
		return {
			colorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),
			isOpen: false,
		}
	},

	computed: {
		currencyName() {
			return this.$store.state.currency
		},
		currency: {
			get: function () {
				return this.$store.state.currency
			},
			set: function (val) {
				this.$store.dispatch('changeCurrency', val)
			}
		},

	},

	mounted() {
		document.addEventListener("click", this.handleClickOutside)
	},

	beforeDestroy() {
		document.removeEventListener("click", this.handleClickOutside)
	},

	methods: {
		toggleOption() {
			this.isOpen = !this.isOpen
		},

		handleClickOutside(e) {
			if (!this.$refs.wrapper.contains(e.target)) {
				this.isOpen = false
			}
		},
	},

}
</script>

<style scoped>
.select-box {
	position: relative;
	background-color: var(--grey-1-color);
	/* padding: 0.5em 0.75em; */
}

.selected-currency {
	position: relative;
	color: white;
	background-color: var(--grey-1-color);
	padding: 0.5rem 0.75rem;
	height: 2.5rem;
	z-index: 2;
}

.selected-currency:hover {
	cursor: pointer;
}

/* Arrow */
.app-select-arrow {
	transition: transform 0.25s ease;
}
.app-select-arrow.open {
	transform: rotate(180deg);
}


/* .selected-currency::after {
	position: relative;
	content: '<';
	margin-left: 14px;
	margin-bottom: 1px;
	font-size: 1.25em;

	transform: rotateZ(-90deg);
} */

.selected-currency.active::after {
	transform: translateX(0px) rotateZ(-270deg);
}

.app-select-dropdown {
	position: absolute;
	background-color: var(--grey-1-color);
	top: 100%;
	right: 0;
	padding: 1.25em 1em 1em 1em;
	margin-top: 0.25rem;
	min-width: fit-content;
	border-radius: 4px;
	border-top-right-radius: 0;
	box-shadow: 0px 0px 10px -3px black;
}

.custom-select {
	background-color: var(--grey-1-color);
	border-color: rgba(255, 255, 255, 0.3);
}

.c-custom-select {
	display: block;
	width: 100%;
	background-color: var(--grey-1-color);
	border: solid rgba(255, 255, 255, 0.3) 1px;
	padding: 0.5rem 0.25rem;
	color: white;
}
</style>